module.exports = __webpack_public_path__ + "img/logo-simple-shadow.0e8bc79c.png";